module.exports = __webpack_public_path__ + "img/754.a9262588.png";